import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";

const UserList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/admin/administrators", {
    params: {
      ...payload,
    },
  });

  const userData = data as any;

  const navigateToDetails = () => {
    navigate("/user-controls/users/create");
  };

  const userDisplayColumns = ["fullName", "phone", "email"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Users",
    headerTitle: "Users",
    buttonTitle: "Create",
    titleBarNodes: (userData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: userData?.entityPermissions
      ? !userData?.entityPermissions?.includes("User-Create")
      : false,
    subHeading: "",
    rowCount: userData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="User"
          data={userData?.items ?? []}
          displayColumns={userDisplayColumns}
          linkColumn="fullName"
          linkUrl="/user-controls/users"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={userData?.totalItems}
          deleteApiUrl="/admin/administrators"
          refetchFunction={fetchData}
          disabled={
            userData?.entityPermissions
              ? !userData?.entityPermissions?.includes("User-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default UserList;
